"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var asyncScriptLoader = require('./helpers/asyncScriptLoader.js').default;
var reactResource = 'https://unpkg.com/react@17/umd/react.production.min.js';
var reactDOMResource = 'https://unpkg.com/react-dom@17/umd/react-dom.production.min.js';
var includeReact = function () { return __awaiter(void 0, void 0, void 0, function () {
    var error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 5, , 6]);
                if (!(reactResource !== 'none')) return [3 /*break*/, 2];
                return [4 /*yield*/, asyncScriptLoader(reactResource, 'reactBundleLoaded')];
            case 1:
                _a.sent();
                _a.label = 2;
            case 2:
                if (!(reactDOMResource !== 'none')) return [3 /*break*/, 4];
                return [4 /*yield*/, asyncScriptLoader(reactDOMResource, 'reactBundleLoaded')];
            case 3:
                _a.sent();
                _a.label = 4;
            case 4: return [3 /*break*/, 6];
            case 5:
                error_1 = _a.sent();
                console.error(error_1);
                return [3 /*break*/, 6];
            case 6: return [2 /*return*/];
        }
    });
}); };
var includeIndex = function () {
    try {
        require('/Users/tom/www/fachverband-klang/fachverband-klang.de/web/app/plugins/fvk_sewobe_integration/webcomponents/src/index.js');
    }
    catch (error) {
        console.warn('File is not found: /Users/tom/www/fachverband-klang/fachverband-klang.de/web/app/plugins/fvk_sewobe_integration/webcomponents/src/index.js');
    }
};
setTimeout(function () { return __awaiter(void 0, void 0, void 0, function () {
    var error_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (process.env.NODE_ENV === 'development'
                    || (window.React && window.ReactDOM)
                    || (reactResource === 'none' && reactDOMResource === 'none')) {
                    includeIndex();
                    return [2 /*return*/];
                }
                return [4 /*yield*/, includeReact()];
            case 1:
                _a.sent();
                _a.label = 2;
            case 2:
                _a.trys.push([2, 4, , 5]);
                return [4 /*yield*/, new Promise(function (resolve, reject) {
                        var intervalCounts = 0;
                        var interval = setInterval(function () {
                            if (intervalCounts >= 2500) {
                                reject(new Error('Direflow Error: React & ReactDOM was unable to load'));
                            }
                            if (window.React && window.ReactDOM) {
                                clearInterval(interval);
                                resolve(true);
                            }
                            intervalCounts += 1;
                        });
                    })];
            case 3:
                _a.sent();
                includeIndex();
                return [3 /*break*/, 5];
            case 4:
                error_2 = _a.sent();
                console.error(error_2);
                return [3 /*break*/, 5];
            case 5: return [2 /*return*/];
        }
    });
}); });
